// The one office deep-link to a completed visit's own record page (Session ADF; the record pages
// themselves added Session AQW/AQW). Every internal surface that lists a service visit routes
// through this helper so the different paths to the same record stay consistent.
//
// A call-out-type job's own record lives at the call-out's own Hub page, /office/callouts/:calloutId
// -- keyed by the CALL-OUT's id, never the job's (Job.calloutId IS the dispatch attendance for that
// call-out; the two ids are different things). Every other visit type (service, LOLER, remedial
// repair, tech visit, condition report, site inspection) lives at the Visit page,
// /office/jobsheets/:jobId, keyed by the job's own id.
//
// `calloutId` is optional so an EXISTING caller that has not been updated to pass it still gets a
// WORKING link (the pre-AQW list+query-param convention, which JobSheetList/CalloutsPage still
// auto-expand via ?job=), rather than a broken one. A caller that resolves the callout id (the
// calendar's own CalEntry.calloutId, a search result's calloutId) should pass it so the link opens
// the record's own page directly.
//
// Gate the CALLER on whether a record exists (a completed / has-jobsheet visit): a scheduled visit
// has no sheet, so its deep-link would land on a page with nothing to show. This helper only builds
// the href; it never decides whether to show it.
export function serviceRecordHref(jobId: string, jobType: string, calloutId?: string | null): string {
  if (jobType === "callout") {
    return calloutId ? `/office/callouts/${encodeURIComponent(calloutId)}` : `/office/callouts?job=${encodeURIComponent(jobId)}`;
  }
  return `/office/jobsheets/${encodeURIComponent(jobId)}`;
}
